import { fastapiService } from '../../services/fastapiService';

const BASE = '/admin/voice-latency';

export interface PhaseSummary {
  phase: string;
  n: number;
  p50: number;
  p95: number;
  p99: number;
  avg: number;
  max: number;
}

export interface StagesResponse {
  window_hours: number;
  turns: number;
  phases: PhaseSummary[];
  e2e_ms: Omit<PhaseSummary, 'phase'>;
}

export interface RecentCall {
  session_id: string;
  workspace_id: string | null;
  ai_employee_id: string | null;
  turns: number;
  started_at: string | null;
  last_turn_at: string | null;
  e2e_p50_ms: number;
  e2e_p95_ms: number;
  e2e_max_ms: number;
}

export const latencyProfilerApi = {
  stages: (hours: number) =>
    fastapiService.request<StagesResponse>(`${BASE}/stages`, { params: { hours } }),
  recentCalls: (hours: number) =>
    fastapiService.request<{ window_hours: number; calls: RecentCall[] }>(`${BASE}/recent-calls`, {
      params: { hours },
    }),
  callDetail: (sessionId: string) =>
    fastapiService.request(`${BASE}/call/${encodeURIComponent(sessionId)}`),
};
